import * as configureSolarApi from '../store/configureSolarApi';
import * as requestTypes from '../store/requestTypes';

const finanzUebersichtReducer = (state = {
    // KPI + Chart Daten (Einnahmen/Ausgaben pro Jahr)
    MixedBarDiagrammEinnahmenUI: [],
    // Finanzierungstext ("noch noetige Einnahmen: X €")
    JahresFinanzierungsfortschrittUI: '',
    // EVU Rechnungen als HTML
    EvuBillUI: [],
    // PV Rechnungen als HTML
    PvBillUI: {},
    // PV Jahresendabrechnung als HTML
    PvFinalBillUI: [],
    isLoaded: false,
    ...configureSolarApi.initialState
}, action) => {
    switch (action.type) {
        case "RECEIVE_MixDiagrammEinnahmen_finanzUebersichtReducer":
            return { ...state, MixedBarDiagrammEinnahmenUI: action.value, isLoaded: true };
        case "RECEIVE_JahresFinanzierungsfortschritt_finanzUebersichtReducer":
            return { ...state, JahresFinanzierungsfortschrittUI: action.value };
        case "RECEIVE_EvuBill_finanzUebersichtReducer":
            return { ...state, EvuBillUI: action.value };
        case "RECEIVE_PvBill_finanzUebersichtReducer":
            return { ...state, PvBillUI: action.value };
        case "RECEIVE_PvFinalBill_finanzUebersichtReducer":
            return { ...state, PvFinalBillUI: action.value };
        // Bei forceRefresh / Navigation: Alte Daten sofort leeren
        case requestTypes.requestStartType.type:
            return {
                ...state,
                MixedBarDiagrammEinnahmenUI: [],
                JahresFinanzierungsfortschrittUI: '',
                EvuBillUI: [],
                PvBillUI: {},
                PvFinalBillUI: [],
                isLoaded: false
            };
    }

    return configureSolarApi.switchCaseForDefaultActionTypesForReducers(action, state);
};
export default finanzUebersichtReducer;
